export default "__VITE_PUBLIC_ASSET__c35c30e0__"